import styled from "styled-components";
import {
    BlockCollab,
    BlockTitleCollab,
    BadgeCollab,
    FieldGrid,
    Field,
    FieldInput,
    FieldSelect,
    FieldSelectReal,
    Footnote,
    OptLabel,
    SInput,
} from "../index";
import { Controller, useFormContext } from "react-hook-form";
import { Dropdown } from "@fluentui/react-northstar";
import {
    DROPDOWN_COUNTRIES_FORMAT,
    getDataCountryByCode,
} from "../../../constants/countries";
import { useMemo } from "react";
import { WORKING_PERMIT_LIST } from "./BlockInfosPerso";

const incomeOptions = [
    {
        id: 1,
        key: 1,
        header: "Salaire",
    },
    {
        id: 2,
        key: 2,
        header: "Revenus de substitution (chômage)",
    },
    {
        id: 3,
        key: 3,
        header: "Rente",
    },
    {
        id: 4,
        key: 4,
        header: "Revenus de substitution + rente",
    },
];

export default function BlockConjoint() {
    const { control } = useFormContext();
    const all_countries = useMemo(() => DROPDOWN_COUNTRIES_FORMAT(), []);
    return (
        <BlockCollab>
            <BlockTitleCollab>
                Conjoint(e) <BadgeCollab>À compléter par vous</BadgeCollab>
                <ISNote>
                    (uniquement pour le personnel soumis à l'impôt à la source
                    *)
                </ISNote>
            </BlockTitleCollab>

            <FieldGrid>
                <Field>
                    <label>Nom et prénom</label>
                    <Controller
                        control={control}
                        render={({ field: { onChange, value, name, ref } }) => {
                            return (
                                <SInput
                                    fluid
                                    ref={ref}
                                    name={name}
                                    value={value}
                                    onChange={(_, i) => onChange(i.value)}
                                    placeholder={
                                        "Nom et prénom du / de la conjoint(e)"
                                    }
                                />
                            );
                        }}
                        name="partner.full_name"
                    />
                </Field>
                <Field>
                    <label>Date de naissance</label>
                    <Controller
                        control={control}
                        render={({ field: { onChange, value, name, ref } }) => {
                            return (
                                <SInput
                                    fluid
                                    ref={ref}
                                    name={name}
                                    value={value}
                                    onChange={(_, i) => onChange(i.value)}
                                    placeholder={"jj.mm.aaaa"}
                                    type="date"
                                />
                            );
                        }}
                        name="partner.birthdate"
                    />
                </Field>
                <Field>
                    <label>Date de mariage</label>
                    <Controller
                        control={control}
                        render={({ field: { onChange, value, name, ref } }) => {
                            return (
                                <SInput
                                    fluid
                                    ref={ref}
                                    name={name}
                                    value={value}
                                    onChange={(_, i) => onChange(i.value)}
                                    placeholder={"jj.mm.aaaa"}
                                    type="date"
                                />
                            );
                        }}
                        name="partner.marriage_date"
                    />
                </Field>
                <Field>
                    <label>Lieu de travail (pays)</label>
                    <Controller
                        control={control}
                        render={({ field: { onChange, value } }) => (
                            <Dropdown
                                items={all_countries}
                                value={
                                    all_countries[
                                        getDataCountryByCode(value)?.index
                                    ]
                                }
                                onChange={(_, i) => {
                                    return onChange(
                                        i?.value?.detail?.code ?? null
                                    );
                                }}
                                placeholder="Choisir dans la liste"
                                clearable
                                checkable
                                fluid
                            />
                        )}
                        name="partner.working_country"
                    />
                </Field>
                <Field>
                    <label>Date début d'activité</label>
                    <Controller
                        control={control}
                        render={({ field: { onChange, value, name, ref } }) => {
                            return (
                                <SInput
                                    fluid
                                    ref={ref}
                                    name={name}
                                    value={value}
                                    onChange={(_, i) => onChange(i.value)}
                                    placeholder={"jj.mm.aaaa"}
                                    type="date"
                                />
                            );
                        }}
                        name="partner.work_start_date"
                    />
                </Field>
                <Field>
                    <label>
                        Date fin d'activité <OptLabel>(si applicable)</OptLabel>
                    </label>
                    <Controller
                        control={control}
                        render={({ field: { onChange, value, name, ref } }) => {
                            return (
                                <SInput
                                    fluid
                                    ref={ref}
                                    name={name}
                                    value={value}
                                    onChange={(_, i) => onChange(i.value)}
                                    placeholder={"jj.mm.aaaa"}
                                    type="date"
                                />
                            );
                        }}
                        name="partner.work_end_date"
                    />
                </Field>
                <Field>
                    <label>
                        Permis de séjour éventuel du / de la conjoint(e)
                    </label>
                    <Controller
                        control={control}
                        render={({ field: { onChange, value, name, ref } }) => {
                            const findValue =
                                WORKING_PERMIT_LIST.find(
                                    (item) => item === value
                                ) ?? undefined;
                            return (
                                <Dropdown
                                    placeholder="Choisir"
                                    items={WORKING_PERMIT_LIST}
                                    value={findValue}
                                    onChange={(_, i) => {
                                        return onChange(i?.value ?? null);
                                    }}
                                    checkable
                                    clearable
                                    fluid
                                    name={name}
                                    ref={ref}
                                />
                            );
                        }}
                        name="partner.working_permit"
                    />
                </Field>
                <Field>
                    <label>Type de revenu du / de la conjoint(e)</label>
                    <Controller
                        control={control}
                        render={({ field: { onChange, value, name, ref } }) => {
                            const findValue = incomeOptions.find(
                                (iO) => iO.id === value
                            );
                            return (
                                <Dropdown
                                    placeholder="Choisir"
                                    clearable
                                    items={incomeOptions}
                                    value={findValue}
                                    onChange={(_, i) => {
                                        return onChange(i?.value?.id ?? null);
                                    }}
                                    ref={ref}
                                    name={name}
                                    checkable
                                    fluid
                                />
                            );
                        }}
                        name="partner.working_type"
                    />
                </Field>
            </FieldGrid>

            <Footnote>
                * Pour toute question concernant votre éligibilité au
                prélèvement à la source ou pour toute autre demande, veuillez
                prendre contact avec votre référent RH.
            </Footnote>
        </BlockCollab>
    );
}

const ISNote = styled.span`
    font-size: 11px;
    font-weight: 400;
    color: var(--text-tert);
    text-transform: none;
    letter-spacing: 0;
`;
